import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, Drawer, IconButton } from '@mui/material';
import { ArrowRight2, Message2, MessageQuestion } from 'iconsax-react';
import { Icon } from '@iconify/react';
import { useAppSelector } from '@application/store/useStore';
import EventRegistrationLanguageSwitcher from './EventRegistrationLanguageSwitcher';
import { useEventRegistrationLanguageContext } from './EventRegistrationLanguageContext';
import { useEventRegistrationTranslation } from './hooks/useEventRegistrationTranslation';
import ContactUsDrawer from './ContactUsDrawer';
import EventRegistrationFaqsDrawer from './EventRegistrationFaqsDrawer';
import EventRegistrationSummaryDrawer from './EventRegistrationSummaryDrawer';
import { useEventRegistrationDrawerContext } from './EventRegistrationDrawerContext';
import { eventRegistrationDrawerCloseButtonSx, eventRegistrationDrawerPaperProps, eventRegistrationDrawerSlideProps } from './eventRegistrationDrawerStyles';
import EmbeddedPreviewSheet from './EmbeddedPreviewSheet';
const EventRegistrationDrawers = () => {
    const { t } = useEventRegistrationTranslation();
    const { VDKEventForRegistration } = useAppSelector((state) => state.VDKEvent);
    const { registrationCategories } = useAppSelector((state) => state.faqCategory);
    const { eventLanguages, selectedLanguageId, handleLanguageChange } = useEventRegistrationLanguageContext();
    const { embeddedPreview, previewLayout, hideNavLinks, isMobileMenuOpen, contactUsOpen, faqsOpen, closeMobileMenu, openContactUs, closeContactUs, openFaqs, closeFaqs } = useEventRegistrationDrawerContext();
    const hasFaqs = registrationCategories.some((c) => c.questions && c.questions.length > 0);
    const mobileNavItems = [
        {
            label: t('eventRegistration.contactUs'),
            icon: _jsx(Message2, { size: 20 }),
            onClick: openContactUs
        },
        ...(hasFaqs
            ? [
                {
                    label: t('eventRegistration.faqs'),
                    icon: _jsx(MessageQuestion, { size: 20 }),
                    onClick: openFaqs
                }
            ]
            : [])
    ];
    const mobileMenuContent = (_jsxs(_Fragment, { children: [_jsx(Box, { display: 'flex', justifyContent: 'flex-end', children: _jsx(IconButton, { onClick: closeMobileMenu, "aria-label": t('actions.close'), sx: eventRegistrationDrawerCloseButtonSx, children: _jsx(Icon, { icon: 'mdi:close', fontSize: 16 }) }) }), !hideNavLinks && (_jsx(Box, { display: 'flex', flexDirection: 'column', gap: 0, alignItems: 'flex-start', width: '100%', children: mobileNavItems.map((item) => (_jsxs(Button, { variant: 'text', onClick: item.onClick, sx: {
                        fontSize: '14px',
                        fontWeight: 500,
                        color: '#00244D',
                        padding: '8px 0',
                        lineHeight: 1.2,
                        minHeight: 'auto',
                        textTransform: 'none',
                        justifyContent: 'space-between',
                        width: '100%',
                        '&:hover': {
                            backgroundColor: 'transparent'
                        }
                    }, children: [_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1 }, children: [item.icon, item.label] }), _jsx(ArrowRight2, { size: 16, color: '#00244D' })] }, item.label))) })), _jsx(EventRegistrationLanguageSwitcher, { eventLanguages: eventLanguages, selectedLanguageId: selectedLanguageId, onLanguageChange: handleLanguageChange, variant: 'drawer' })] }));
    const drawers = (_jsxs(_Fragment, { children: [embeddedPreview ? (_jsx(EmbeddedPreviewSheet, { open: isMobileMenuOpen, onClose: closeMobileMenu, previewLayout: previewLayout, children: _jsx(Box, { sx: {
                        px: 2,
                        pt: 2,
                        pb: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2,
                        height: '100%',
                        overflowY: 'auto'
                    }, children: mobileMenuContent }) })) : (_jsx(Drawer, { anchor: 'right', open: isMobileMenuOpen, onClose: closeMobileMenu, SlideProps: eventRegistrationDrawerSlideProps, PaperProps: {
                    ...eventRegistrationDrawerPaperProps,
                    sx: {
                        ...eventRegistrationDrawerPaperProps?.sx,
                        px: 2,
                        pt: 2,
                        pb: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 2
                    }
                }, children: mobileMenuContent })), _jsx(EventRegistrationFaqsDrawer, { open: faqsOpen, onClose: closeFaqs, onContactUsOpen: openContactUs, embeddedPreview: embeddedPreview, previewLayout: previewLayout }), _jsx(ContactUsDrawer, { open: contactUsOpen, onClose: closeContactUs, onFAQOpen: openFaqs, phone: VDKEventForRegistration?.contactEventTeamPhone, email: VDKEventForRegistration?.contactEventTeamEmail, hasFaqs: hasFaqs, embeddedPreview: embeddedPreview, previewLayout: previewLayout }), _jsx(EventRegistrationSummaryDrawer, { embeddedPreview: embeddedPreview, previewLayout: previewLayout })] }));
    if (!embeddedPreview) {
        return drawers;
    }
    return (_jsx(Box, { sx: {
            position: 'absolute',
            inset: 0,
            zIndex: 1300,
            overflow: 'hidden',
            pointerEvents: 'none'
        }, children: drawers }));
};
export default EventRegistrationDrawers;
